/**
 * Sanitize Schema for react-markdown (rehype-sanitize)
 *
 * Restricts allowed HTML to a safe subset used by our markdown renderer.
 * Ensures we can safely enable rehype-raw for inline HTML like <br> while
 * preventing unsafe tags/attributes.
 */

import type { Schema } from 'hast-util-sanitize';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';

// Extend the default schema with table-related tags and link attributes
export const sanitizeSchema: Schema = {
  ...defaultSchema,
  tagNames: Array.from(
    new Set([
      ...(defaultSchema.tagNames || []),
      'table',
      'thead',
      'tbody',
      'tr',
      'td',
      'th',
      'br',
      'code',
      'pre',
      'blockquote',
      'img',
    ])
  ),
  attributes: {
    ...(defaultSchema.attributes || {}),
    a: [
      ...(((defaultSchema.attributes || {}).a as any[]) || []),
      // Allow basic anchor attributes
      'href',
      'target',
      'rel',
      // Allow data attributes if needed in future
      ['data-*'] as unknown as any,
    ],
    td: [
      ...(((defaultSchema.attributes || {}).td as any[]) || []),
      'colspan',
      'rowspan',
    ],
    th: [
      ...(((defaultSchema.attributes || {}).th as any[]) || []),
      'colspan',
      'rowspan',
    ],
    img: [
      'src',
      'alt',
      'title',
      'loading',
      'decoding',
      'width',
      'height',
    ],
  },
  protocols: {
    ...(defaultSchema.protocols || {}),
    src: ['http', 'https', 'data'],
  },
};

export default rehypeSanitize;

